import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";

import detalhesInteresses from "../../images/detalhesInteresses.png";

import proximo from "../../images/proximo.png";

import maisCotas from "../../images/sinalMaisIcon.png";
import interesses from "../../images/interesses.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
  button {
    border: none;

    background: transparent;
    &:hover {
      cursor: pointer;
    }
  }
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 20%;

  @media (min-width: 500px) {
    width: 15%;
  }

  @media (min-width: 600px) {
    width: 10%;
  }
  @media (min-width: 700px) {
    width: 8%;
  }
  @media (min-width: 900px) {
    width: 6%;
  }
`;
const ImagemMaior = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;

  @media (min-width: 900px) {
    width: 90%;
  }
`;

const ImagemProsseguir = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 13%;
  justify-self: center;
  @media (min-width: 500px) {
    width: 10%;
  }
  @media (min-width: 700px) {
    width: 7%;
  }
  @media (min-width: 900px) {
    width: 5%;
  }
`;
const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;

  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  #text {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  #button {
    a {
      width: 100%;

      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  #voltar {
    diplay: grid;

    grid-template: 50% 50% / 100%;
    align-items: center;
    justify-content: center;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  width: 80%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (min-width: 400px) {
    font-size: 1.5rem;
  }
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
`;

const H3 = styled.h3`
  text-align: left;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;

  @media (min-width: 400px) {
    font-size: 1.2rem;
  }
`;

export default function ViewPrimeiraVezInteresse() {
  const goBack = () => {
    // eslint-disable-next-line no-restricted-globals
    history.back();
  };
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>COMO CADASTRAR UM INTERESSE?</Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <H3>
            <br />
            <p> 1º Clique no botão "+" no canto superior direito </p>
            <Imagem src={maisCotas}></Imagem>
            <p>
              {" "}
              2º identifique a localização, as características e o período de
              interesse, depois clique em incluir:
            </p>
            <ImagemMaior src={detalhesInteresses}></ImagemMaior>
            <br />
            <p>
              {" "}
              3º O interesse incluído aparecerá na relação de interesses.
              Indique se deseja alugar (pagar para se hospedar) ou trocar.
            </p>
            <ImagemMaior src={interesses}></ImagemMaior>
            <br />
            <p>
              Pronto! Interesse incluído com sucesso! Basta aguardar e será
              notificado assim que encontrarmos um período disponibilizado
              compatível.
            </p>
            <p> Obs: </p>
            <p>
              1 - Clicando em cotas você poderá cadastrar suas cotas e
              disponibilizar seus períodos para troca, caso não tenha feito
              ainda.
            </p>
            <p>
              2 - Clicando em detalhes é possível visualizar ou alterar as
              informações do seu interesse.
            </p>
            <p>
              3 - Caso deseje alugar (pagar para se hospedar), indique o valor
              máximo a pagar. Não se preocupe, se encontrarmos uma oferta de
              menor valor, você pagará menos do que o valor indicado. Esse valor
              máximo não será exibido para os cotistas, somente a plataforma
              conhecerá. Ele servirá apenas para que você não seja notificado
              sobre ofertas de maior valor.
            </p>{" "}
            <div id="voltar">
              <div id="text">
                <p>Prosseguir com o cadastro do interesse</p>
              </div>
              <div id="button">
                <a href="/interesses">
                  <ImagemProsseguir src={proximo} />
                </a>
              </div>
            </div>
          </H3>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
